import React from 'react';

interface BackgroundProps {
  onOpenTerminal: () => void;
}

const Background: React.FC<BackgroundProps> = ({ onOpenTerminal }) => {
  return (
    <div className="fixed inset-0 bg-black flex items-center justify-center overflow-hidden">
      {/* Grid lines */}
      <div className="absolute inset-0 bg-[#031209] opacity-20" 
           style={{ 
             backgroundImage: 'linear-gradient(to right, #0f3323 1px, transparent 1px), linear-gradient(to bottom, #0f3323 1px, transparent 1px)',
             backgroundSize: '20px 20px'
           }}>
      </div>
      
      {/* Futuristic logo */}
      <div className="relative">
        <div className="text-[#5fe979] text-center">
          {/* Retro computer logo */}
          <div className="relative w-64 h-64 mx-auto mb-8">
            {/* Monitor outline */}
            <div className="absolute w-56 h-44 border-4 border-[#5fe979] top-6 left-4 rounded-lg"></div>
            
            {/* Screen */}
            <div className="absolute w-48 h-36 bg-[#031209] top-10 left-8 rounded">
              {/* Text on screen */}
              <div className="absolute inset-0 flex flex-col items-center justify-center">
                <div className="text-3xl font-bold mb-1 tracking-widest">GB4K</div>
                <div className="text-xs tracking-wide">PERSONAL TERMINAL</div>

                {/* Blinking cursor */}
                <div className="absolute bottom-4 right-4 w-2 h-4 bg-[#5fe979] animate-pulse"></div>
              </div>
            </div>
            
            {/* Keyboard */}
            <div className="absolute w-64 h-14 bg-[#153525] bottom-0 left-0 rounded-md border-t-2 border-[#5fe979]">
              <div className="grid grid-cols-12 gap-1 p-2">
                {[...Array(24)].map((_, i) => (
                  <div key={i} className="h-2 bg-[#0a1a12] rounded-sm"></div>
                ))}
              </div>
            </div>
            
            {/* Disk drive */}
            <div className="absolute w-20 h-6 bg-[#153525] top-52 left-22 rounded border border-[#5fe979]">
              <div className="absolute top-2 left-2 w-3 h-2 bg-[#031209]"></div>
              <div className="absolute top-2 right-2 w-2 h-2 rounded-full bg-[#5fe979] animate-pulse"></div>
            </div>
          </div>
          
          {/* Name display */}
          <div className="text-2xl font-bold mb-6 relative">
            <span className="relative z-10">gb4k.fr</span>
            <div className="absolute inset-0 bg-[#5fe979] opacity-10 blur-lg"></div>
          </div>
          
          <button 
            onClick={onOpenTerminal}
            className="text-sm mt-2 opacity-70 hover:opacity-100 hover:underline cursor-pointer px-4 py-2 bg-[#245032] text-[#5fe979] border border-[#5fe979] rounded-md hover:bg-[#132a1b] transition-colors"
          >
            Open Terminal
          </button>
        </div>
      </div>
    </div>
  );
};

export default Background;